import {
    Component, Input, OnInit,
} from '@angular/core';
import { Router } from '@angular/router';
import { ServicecallService } from 'src/app/services';


export interface TripPoint {
    lat: number;
    lng: number;
    ts: number; // ms
    speed?: number;
    events?: { type: string; label?: string }[];
}

@Component({
    selector: 'app-dtc-predictions',
    templateUrl: './dtc-predictions.component.html',
    styleUrl: './dtc-predictions.component.css'
})
export class DtcPredictionsComponent implements OnInit {

    @Input() entityData: any;
    isloader: boolean = false
    dtcPredictionsHeaders: any = {};
    predictionUrl: boolean = false;
    dtcPredictionData: any[] = [];

    constructor(public router: Router, private sharedService: ServicecallService) { }

    ngOnInit(): void {
        this.dtcPredictionsHeaders = this.sharedService.getConfiguration('dtcPrediction')?.profile?.dtcPredictionsHeaders || { "dtc": "DTC Code", "description": "Description", "predictionConfidence": "Prediction Confidence", "breakdownRisk": "Breakdown Risk", "subsystem": "Subsystem", "predictionState": "State" };
        this.dtcPredictionData = this.sharedService.getConfiguration('dtcPrediction')?.profile?.dtcPredictionData || [{
            "dtc": "P0420",
            "description": "Catalyst System Efficiency Below Threshold (Bank 1)",
            "predictionConfidence": "95%",
            "breakdownRisk": "73%",
            "subsystem": "Ignition System",
            "predictionState": "high"
        },
        {
            "dtc": "P0300",
            "description": "Random/Multiple Cylinder Misfire Detected",
            "predictionConfidence": "85%",
            "breakdownRisk": "65%",
            "subsystem": "Sensor",
            "predictionState": "medium"
        },
        {
            "dtc": "P0171",
            "description": "System Too Lean (Bank 1)",
            "predictionConfidence": "92%",
            "breakdownRisk": "70%",
            "subsystem": "Fuel System",
            "predictionState": "low"
        }];
        this.dtcPredictionData = this.dtcPredictionData.map(item => {
            const risk = parseFloat(item?.breakdownRisk);
            return {
                ...item,
                predictionState: this.getPredictionState(risk)
            };
        });
    }

    tableAction(event: any) {
        if (event?.type === 'predictionConfidence') {
            const edate = this.formatEdate(new Date());

            this.router.navigate(
                ['/vehicles/profile', this.entityData?._id, 'predictions'],
                {
                    queryParams: {
                        dtc: event?.item?.dtc,
                        vin: this.entityData?.uniqueId,
                        edate,
                        risk: parseFloat(event?.item?.breakdownRisk),
                        prediction: parseFloat(event?.item?.predictionConfidence),
                        pageType: 'vehicleProfilePrediction',
                        entityId: this.entityData?._id
                    }
                }
            );
        }
    }

    getPredictionState(breakdownRisk: number): 'high' | 'medium' | 'low' {
        if (breakdownRisk > 70) {
            return 'high';
        } else if (breakdownRisk > 50) {
            return 'medium';
        } else {
            return 'low';
        }
    }

    private formatEdate(date: Date): string {
        return date.toLocaleString('en-US', {
            month: 'short',
            day: 'numeric',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
        });
    }
}